<template>
  <section>
    <notifications></notifications>

    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/rates/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Rate</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search py-0">
                <b-input-group-prepend
                  class="pt-1 pl-1 d-sm-inline-block d-none"
                >
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>

                <el-select
                  placeholder="Select Destination"
                  v-model="branch"
                  id="branch_name"
                  name="branch_name"
                  filterable
                  reserve-keyword
                  :filter-method="filterOptions"
                  @change="selectedBranch"
                  value
                  class="select-filter d-inline-flex"
                  clearable
                >
                  <el-option
                    v-for="branch in branches"
                    :value="branch._id"
                    :label="branch.name"
                    :key="branch._id"
                  >
                    <span class="hide-data-inline">{{ branch.name }}</span>
                  </el-option>
                </el-select>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-7 col-lg-6 col-md-5 col-sm-12 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'ALL' ? 'active' : ''"
                    @click="applyFilterByStatus('ALL')"
                  >
                    <i class="flaticon-rec text-primary mr-2"></i>
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'ACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('ACTIVE')"
                  >
                    <i class="flaticon-bold-check-3 text-success mr-2"></i>
                    Active
                  </div>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'INACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('INACTIVE')"
                  >
                    <i class="flaticon-bold-cancel text-danger mr-2"></i>
                    Inactive
                  </div>

                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'EXPIRED' ? 'active' : ''"
                    @click="applyFilterByStatus('EXPIRED')"
                  >
                    <i class="flaticon-time-left text-neutral mr-2"></i>
                    Expired
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows-2"
              >
                <b-form-radio value="ALL">All</b-form-radio>
                <b-form-radio value="EXPIRED"
                  >Expired<badge type="danger" class="square">{{
                    expiredNumber
                  }}</badge></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-2 text-right"
          >
            <div class="col-xl-6 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class=""
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="rates.pages"
            v-model="currentPage"
            :total="rates.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="items"
            :fields="fields"
            sort-by.sync="category"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length === items.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #thead-top="data">
              <draggable
                tag="b-tr"
                v-model="fields"
                @change="changDraggable"
                draggable=".dragg"
                sortable="true"
                :sort="true"
              >
                <b-th
                  v-for="(field, index) in fields"
                  :key="index"
                  class="draggable text-center"
                  :class="[
                    {
                      'no-drag': !field.settings.drag,
                      dragg: field.settings.drag,
                      'b-table-sort-icon-left': field.sortable
                    }
                  ]"
                  style="padding: 0px 10px 10px 10px !important"
                  :width="field.width"
                >
                  <span class="drag-drop" v-if="field.settings.drag"> </span>
                </b-th>
              </draggable>
            </template>

            <template #cell(category)="data">
              <router-link
                :to="
                  data.item.rate.branch && data.item.rate.branch.supplier
                    ? `/rates/${data.item.rate._id}?branch=${data.item.rate.branch._id}&operator=${data.item.rate.branch.supplier._id}`
                    : `/rates/${data.item.rate._id}`
                "
                class="box-img-card"
                v-if="data.item.rate.vehicle"
              >
                <div class="img-car">
                  <img
                    :src="data.item.rate.vehicle.information.image"
                    class="img-fluid es-img-service-2"
                    alt="Service Car"
                  />
                </div>

                <div class="content">
                  <span class="capitalize hide-data title">
                    {{
                      formatCatergory(
                        data.item.rate.vehicle.parameters.category
                      )
                    }}
                  </span>

                  <span
                    class="hide-data subtitle-1"
                    v-if="data.item.rate.vehicle"
                    >{{ data.item.rate.vehicle.parameters.name }}</span
                  >
                  <span
                    class="hide-data subtitle-2"
                    v-if="data.item.rate.vehicle"
                    >{{
                      formatVehicleType(data.item.rate.vehicle.parameters.type)
                    }}</span
                  >
                </div>
              </router-link>
            </template>

            <template #cell(destination)="data">
              <span class="hide-data" v-if="data.item.rate.branch"
                >{{ data.item.rate.branch.name }}
              </span>
            </template>

            <template #cell(pricingSelections)="data">
              <span>
                {{ formatRateType(data.item.rate.type_of_quote) }}
              </span>
            </template>

            <template #cell(seats)="data">
              <span>
                {{ data.item.rate.vehicle.parameters.n_seats }}
              </span>
            </template>

            <template #cell(childSeats)="data">
              <span>{{ data.item.rate.child_seat.number }}</span>
            </template>

            <template #cell(childSeatPrice)="data">
              <span>
                {{ data.item.rate.currency_symbol }}
                {{ data.item.rate.child_seat.price }}
                {{ data.item.rate.currency_code }}
              </span>
            </template>

            <template #cell(currency)="data">
              <span>
                {{ data.item.rate.currency_code }}
              </span>
            </template>

            <template #cell(areas)="data">
              <span class="hide-data">{{
                getAreaOfActionLength(data.item.rate.area_of_action)
              }}</span>
            </template>

            <template #cell(especialConditions)="data">
              <span> {{ getSurcharges(data.item.rate.surcharges) }} </span>
            </template>

            <template #cell(minbasePriceByArea)="data">
              <div v-if="getAreaOfActionLength(data.item.rate.area_of_action)">
                <span
                  >{{ data.item.rate.currency_symbol }}
                  {{ getMinPrice(data.item.rate.area_of_action) }}
                  {{ data.item.rate.currency_code }}</span
                >
              </div>
              <div v-else>
                <span
                  >{{ data.item.rate.currency_symbol }}
                  {{ addecimal(data.item.rate.base_price) }}
                  {{ data.item.rate.currency_code }}</span
                >
              </div>
            </template>

            <template #cell(priceByDistance)="data">
              <span>
                {{ data.item.rate.currency_symbol }}
                {{ addecimal(data.item.rate.price_extra_km) }}
                {{ data.item.rate.currency_code }}
              </span>
            </template>

            <template #cell(validity)="data">
              <span class="d-block"
                ><strong>From: </strong>
                {{ getDateFormat(data.item.rate.validity_date.start) }}
              </span>
              <span class="d-block">
                <strong>To: </strong>
                {{ getDateFormat(data.item.rate.validity_date.end) }}
              </span>
            </template>

            <template #cell(status)="data">
              <span
                class="badge-status"
                v-bind:class="getClassByRateStatus(data.item.rate.status)"
              >
                {{ getRateStatus(data.item.rate.status) }}
              </span>
            </template>

            <template #cell(basePrice)="data">
              <span>
                {{ data.item.rate.currency_symbol }}
                {{ data.item.rate.base_price }}
                {{ data.item.rate.currency_code }}
              </span>
            </template>

            <template #cell(minimumDisposition)="data">
              <span v-if="data.item.rate.hours_disposition.min_hours">
                {{ data.item.rate.hours_disposition.min_hours }}
              </span>
              <span v-else> N/A </span>
            </template>

            <template #cell(maximumDisposition)="data">
              <span v-if="data.item.rate.hours_disposition.status">
                {{ data.item.rate.hours_disposition.max_hours }}
              </span>
              <span v-else> N/A </span>
            </template>

            <template #cell(distanceInclude)="data">
              <span v-if="data.item.rate.hours_disposition.km_include">
                {{ data.item.rate.hours_disposition.km_include }}
              </span>
              <span v-else> N/A </span>
            </template>

            <template #cell(priceByDisposition)="data">
              <span v-if="data.item.rate.hours_disposition.price_by_hour">
                {{ data.item.rate.currency_symbol }}
                {{ data.item.rate.hours_disposition.price_by_hour }}
                {{ data.item.rate.currency_code }}
              </span>
              <span v-else="data.item.rate.hours_disposition.price_by_hour">
                N/A
              </span>
            </template>

            <template #cell(meetAndGreetPrice)="data">
              <span>
                {{ data.item.rate.currency_symbol }}
                {{ data.item.rate.meet_greet_price }}
                {{ data.item.rate.currency_code }}
              </span>
            </template>

            <template #cell(actions)="data">
              <el-tooltip
                content="History"
                placement="bottom"
                class="d-inline-flex"
              >
                <span
                  class="icon-action text-blue mr-2"
                  @click.stop="openRateHistory(data.item._id)"
                >
                  <i class="flaticon-wall-clock-1"> </i>
                </span>
              </el-tooltip>
              <el-tooltip content="Edit" placement="bottom">
                <router-link
                  class="icon-action text-blue"
                  :to="
                    data.item.rate.branch && data.item.rate.branch.supplier
                      ? `/rates/${data.item.rate._id}?branch=${data.item.rate.branch._id}&operator=${data.item.rate.branch.supplier._id}`
                      : `/rates/${data.item.rate._id}`
                  "
                >
                  <i class="flaticon-pencil text-primary"></i>
                </router-link>
              </el-tooltip>

              <el-tooltip content="Change status" placement="bottom">
                <span
                  class="icon-action ml-2"
                  @click.stop="
                    changeRateStatus(data.item.rate._id, data.item.rate.status)
                  "
                >
                  <i class="flaticon-right-4 text-info"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click="deleteRate(data.item.rate._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="rates.pages"
            v-model="currentPage"
            :total="rates.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>

      <ManageTableColumns
        :value="modalManageColumn"
        :fields="fields"
        :tableGridConfig="tableGridConfig"
        :madatories="['category', 'destination']"
        @saveColumns="saveColumnsInUserAccount"
        @closeTableGridModal="closeTableGridModal"
      />
    </div>
    <RateHistory
      :show="showRateHistory"
      :tempRateId="tempRateId"
      @close="closeRateHistoryModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import Swal from "sweetalert2";
import endpoint from "../../Commons/Services/index";
import moment from "moment";
import localHelper from "../commons/Helper/index.js";
import WSelect from "@/components/Select";
import RateHistory from "../components/RateHistory.vue";
import ManageTableColumns from "../../../components/ManageTableColumns.vue";
import draggable from "vuedraggable";
import TableGrid from "../../Commons/Utility/TableGrid/index.js";
import {
  goBack,
  unauthorizedAction
} from "../../../helpers/commons.helpers.js";
import { max } from "lodash";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Rates",
  data() {
    return {
      selectedRows: [],
      operators: [],
      branches: [],
      currentPage: 1,
      branch: "",
      limit: 0,
      modalManageColumn: false,
      fields: [],
      tableGridConfig: TableGrid.rates,
      cardview: false,
      selected: [],
      currentBranch: null,
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        { value: "currency", text: "Currency" },
        { value: "created_at", text: "Created At" }
      ],
      query: "",
      view: "table",
      tempRateId: null,
      showRateHistory: false,
      rateStatus: "ALL",
      pusher: null,
      filterStatus: "ALL",
      expired: 20,
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },
  watch: {
    branchesOptions: {
      handler: async function(current, old) {
        this.branches = current;
      },
      deep: true
    }
  },
  async created() {
    this.fields = this.populateFiles(this.moduleSettings);
    this.sortBySync = this.getSortBySync(this.moduleSettings);
    this.sortDescSync = this.getSortDescSync(this.moduleSettings);
    this.query = this.getQuery(this.moduleSettings);
    var bread = [
      {
        text: "Rates",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getOperatorsSelections();
    await this.getBranchesOptions();
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.query = this.ratesSearchCriteria.query;
    this.currentPage = this.ratesSearchCriteria.currentPage;
    this.branch = this.getBranchId(
      this.ratesSearchCriteria,
      this.$route.query.branch
    );
    await this.initFilters(this.query);
    this.initData(this.branch);
  },
  methods: {
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.tableLayouts": this.fields }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setModuleSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let {
          data
        } = await endpoint.settings.services.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.rates.tableLayouts.length > 0) {
            return settings.rates.tableLayouts;
          } else {
            return TableGrid.rates.filter(option => {
              return option.settings.default;
            });
          }
        } else {
          return TableGrid.rates.filter(option => {
            return option.settings.default;
          });
        }
      } catch (error) {
        return TableGrid.rates.filter(option => {
          return option.settings.default;
        });
      }
    },
    getSortBySync(settings) {
      try {
        if (settings) {
          if (settings.rates.sortBySync) {
            return settings.rates.sortBySync;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    getQuery(settings) {
      try {
        if (settings) {
          if (settings.rates.query) {
            return settings.rates.query;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    async changeSortByAsync(sortBySync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.sortBySync": sortBySync }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    async changeQuery(query) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.query": query }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    getSortDescSync(settings) {
      try {
        if (settings) {
          if (settings.rates.sortBySync) {
            return settings.rates.sortDescSync;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async changeSortDescSync(sortDescSync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.sortDescSync": sortDescSync }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    async selectedBranch(branchId) {
      if (branchId) {
        let branch = this.branchesOptions.find(
          element => element._id === branchId
        );
        this.currentBranch = branch;
        if (this.currentBranch) {
          this.$router.replace({ query: { branch: this.currentBranch._id } });
          this.currentPage = 1;
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
        }
      } else {
        this.currentPage = 1;
        this.currentBranch = null;
        await this.get(true, this.limit, this.currentPage, this.query, null);
      }
    },
    async changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        let branch = this.currentBranch ? this.currentBranch._id : null;
        if (this.filterStatus === "ALL") {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.query,
            branch
          );
        } else {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp,
            branch
          );
        }
      }
    },
    async preventPaginations(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    async nextPaginations(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    async changePage(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    filterOptions(input) {
      if (input !== "" && input.length > 2) {
        this.branches = this.branchesOptions.filter(branch => {
          return branch.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
        });
      } else {
        if (input === "") {
          this.branches = this.branchesOptions;
        } else {
          this.branches = [];
        }
      }
    },
    async deleteRate(rateId) {
      let { value } = await Swal.fire({
        title: "Delete Rate",
        text: "Are you sure do you want to delete this Rate?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteRateById(rateId);
      }
    },
    async deleteRateById(rateId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.deleteRateById(
          rateId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(
            true,
            this.limit,
            1,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteMany(rates = []) {
      let { value } = await Swal.fire({
        title: "Delete Rates",
        text: "Are you sure do you want to delete the selected Rates?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyRatesById(rates);
      }
    },
    async deleteManyRatesById(rates = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.deleteManyRatesById(
          { services: rates },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(
            true,
            this.limit,
            1,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rates has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async download(rates = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVServices(
          { services: rates },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `rates-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    getAreaOfActionLength(area_of_action) {
      if (area_of_action.length) {
        return area_of_action.length;
      } else {
        if (area_of_action.name != null) {
          return 1;
        }
      }
      return 0;
    },
    getMinPrice(area_of_action) {
      let min_price = 0;
      if (area_of_action.length) {
        let area_of_action_prices = area_of_action.map(
          area_of_action => area_of_action.price
        );
        min_price = Math.min(...area_of_action_prices);
      } else {
        min_price = area_of_action.price;
      }
      return min_price
        ? min_price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
        : 0;
    },
    addecimal: function(price) {
      return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getBranchId(ratesSearchCriteria, queryBranchId) {
      if (ratesSearchCriteria.status) {
        return ratesSearchCriteria.branchId;
      } else {
        return queryBranchId ? queryBranchId : null;
      }
    },
    async initData(branchId) {
      let branch = this.branchesOptions.find(
        element => element._id === branchId
      );
      this.currentBranch = branch;
      await this.get(
        true,
        this.limit,
        1,
        this.query,
        this.currentBranch ? this.currentBranch._id : null
      );
    },
    async initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        let rateStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";
        this.rateStatus = rateStatus !== "EXPIRED" ? rateStatus : "ALL";
        this.filterStatus = rateStatus === "EXPIRED" ? "EXPIRED" : "ALL";
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, limit, page, query, branchId) {
      if (branchId) {
        await this.getRatesByBranchId({
          loader: true,
          branchId: branchId,
          limit: limit,
          page: page,
          query: query
        });
      } else {
        await this.getRates({
          loader: loader,
          limit: limit,
          page: page,
          query: query
        });
      }
      this.setRatesSearchCriteria({
        status: true,
        branchId: branchId,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        await this.get(
          true,
          this.limit,
          this.currentPage,
          this.queryTemp,
          branch
        );
      }
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        await this.get(
          true,
          this.limit,
          this.currentPage,
          this.queryTemp,
          branch
        );
      }
    },
    async applyFilterByStatus(status) {
      this.rateStatus = status;
      this.query =
        status !== "ALL"
          ? this.addElementInQuery(this.query, "status", status)
          : this.deleteItemInQuery(this.query, ["status"]);
      this.filterStatus = "ALL";
      this.currentPage = 1;
      let branch = this.currentBranch ? this.currentBranch._id : null;
      await this.get(true, this.limit, this.currentPage, this.query, branch);
    },
    async filteredTab(value) {
      if (value === "ALL") {
        this.currentPage = 1;
        this.queryTemp = "";
        let branch = this.currentBranch ? this.currentBranch._id : null;
        this.query =
          this.rateStatus === "ALL"
            ? this.deleteItemInQuery(this.query, ["status"])
            : this.addElementInQuery(this.query, "status", this.rateStatus);
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        if (this.expiredNumber > 0) {
          this.currentPage = 1;
          let branch = this.currentBranch ? this.currentBranch._id : null;
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp,
            branch
          );
        } else {
          this.rates.docs = [];
        }
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value.trim());
      } else {
        searchParams.append(key, value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    getSurcharges(surcharges = []) {
      if (surcharges.length) {
        return surcharges.length;
      } else {
        return 0;
      }
    },
    typeEvent(type) {
      if (type === "blackouts") {
        return "Blackouts Dates";
      } else if (type === "special_event") {
        return "Special Event";
      } else if (type === "weekend_dates") {
        return "Weekend Fees";
      } else if (type === "night_fees") {
        return "Night Fees";
      } else if (type === "seasonal") {
        return "Seasonal Fees";
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    openRateHistory(rateId) {
      this.tempRateId = rateId;
      this.showRateHistory = !this.showRateHistory;
    },
    closeRateHistoryModal() {
      this.showRateHistory = false;
      this.tempRateId = null;
    },
    getClassByRateStatus(status) {
      if (status === "ACTIVE") {
        return "badge-success";
      } else if (status === "INACTIVE") {
        return "badge-danger";
      } else if (status === "EXPIRED") {
        return "status-draft";
      } else {
        return {};
      }
    },
    getRateStatus(status) {
      if (status === "ACTIVE") {
        return "Active";
      } else if (status === "INACTIVE") {
        return "Inactive";
      } else if (status === "EXPIRED") {
        return "Expired";
      } else {
        return "Unknow";
      }
    },
    async changeRateStatus(rateId, status) {
      if (status !== "EXPIRED") {
        let { value } = await Swal.fire({
          title: "Change Status Rate",
          html:
            "Are you sure you want to <strong>Change Status</strong> of the selected Rate?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.changeRateStatusById(
            rateId,
            status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Validation error!",
          message: `The Rate couldn't be uploaded. Please update the validity period of this rate.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async changeRateStatusById(rateId, status) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.updateAnyAttributeById(
          rateId,
          { status: status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(
            false,
            this.limit,
            this.currentPage,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate Status has been Updated",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    getDateFormat(date) {
      return moment.utc(date, "YYYY-MM-DD").format("DD-MMM-YYYY");
    },
    formatCatergory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatRateType(type) {
      if (type === "travel") {
        return "By Distance";
      } else {
        return "Area + Distance";
      }
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "RATES");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions([
      "getOperatorsSelections",
      "getBranchesOptionsByOperatorId",
      "getRatesByBranchId",
      "getBranchesOptions",
      "getRates",
      "getLimit"
    ]),
    ...mapMutations([
      "setRatesOfBranch",
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setRatesSearchCriteria",
      "setModuleSettings"
    ])
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    RateHistory,
    ManageTableColumns: ManageTableColumns,
    draggable
  },
  computed: {
    items: function() {
      try {
        let rates = this.rates.docs || [];
        return rates.map(rate => {
          return {
            _id: rate._id,
            category: rate.vehicle ? rate.vehicle.parameters.category : "",
            destination: rate.branch ? rate.branch.name : "",
            pricingSelections:
              rate.type_of_quote === "area" ? "Area + Distance" : "By Distance",
            seats: rate.vehicle ? rate.vehicle.parameters.n_seats : 0,
            childSeats: rate.child_seat.number,
            childSeatPrice: rate.child_seat.price,
            areas: this.getAreaOfActionLength(rate.area_of_action),
            especialConditions: rate.surcharges.length,
            minbasePriceByArea: this.getMinPrice(rate.area_of_action),
            validity: `From: ${this.getDateFormat(
              rate.validity_date.start
            )} To: ${this.getDateFormat(rate.validity_date.end)}`,
            status: rate.status,
            basePrice: rate.base_price,
            priceByDistance: rate.price_extra_km,
            currency: rate.currency_code,
            minimumDisposition: rate.hours_disposition.min_hours,
            maximumDisposition: rate.hours_disposition.max_hours,
            distanceInclude: rate.hours_disposition.km_include,
            priceByDisposition: rate.hours_disposition.price_by_hour,
            meetAndGreetPrice: rate.meet_greet_price,
            rate: rate
          };
        });
      } catch (error) {
        return [];
      }
    },
    expiredNumber: function() {
      if (this.rates.metadata) {
        return this.rates.metadata.expired;
      } else {
        return 0;
      }
    },
    ...mapGetters([
      "operatorSelections",
      "branchesOptionsByOperatorId",
      "rates",
      "branchesOptions",
      "sesion",
      "sigout",
      "paginationLimit",
      "ratesSearchCriteria",
      "moduleSettings"
    ])
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInRatesModule(
      to.meta.modules,
      this.setRatesSearchCriteria,
      "rates"
    );

    next();
  }
};
</script>
